module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (247).b1300b4e.jpg";